var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ies-form-field",
    { attrs: { field: _vm.field } },
    [
      _c("v-autocomplete", {
        attrs: {
          "hide-details": "",
          dense: "",
          outlined: "",
          label: "Link Type",
          items: _vm.typeOptions,
          autocomplete: "",
        },
        model: {
          value: _vm.linkType,
          callback: function ($$v) {
            _vm.linkType = $$v
          },
          expression: "linkType",
        },
      }),
      _vm._v(" "),
      _vm.linkType == 1
        ? _c("v-text-field", {
            attrs: { "hide-details": "", label: "Route Name" },
            model: {
              value: _vm.routeName,
              callback: function ($$v) {
                _vm.routeName = $$v
              },
              expression: "routeName",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.linkType == 2
        ? _c("v-text-field", {
            attrs: { "hide-details": "", label: "URL" },
            model: {
              value: _vm.explicitUrl,
              callback: function ($$v) {
                _vm.explicitUrl = $$v
              },
              expression: "explicitUrl",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.linkType == 3
        ? _c("v-autocomplete", {
            attrs: {
              "hide-details": "",
              dense: "",
              outlined: "",
              label: "Portal Page to Link To",
              items: _vm.portalPageOptions,
              autocomplete: "",
            },
            model: {
              value: _vm.pageID,
              callback: function ($$v) {
                _vm.pageID = $$v
              },
              expression: "pageID",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "hidden", name: _vm.field.fieldName },
        domProps: { value: _vm.field.value },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }